import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Check, ChevronDown, RussianRuble } from "lucide-react";

import { useCurrency } from "../features/currency/CurrencyContext";

export function CurrencySelector() {
  const { currencies, currency, setCurrencyCode } = useCurrency();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="currency-selector" type="button" aria-label="Выбрать валюту">
          <RussianRuble aria-hidden="true" />
          <span>{currency.code === "RUB" ? "РУБ" : currency.code}</span>
          <ChevronDown aria-hidden="true" />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className="currency-menu" align="end" sideOffset={7}>
          <DropdownMenu.RadioGroup
            value={currency.code}
            onValueChange={setCurrencyCode}
          >
            {currencies.map((item) => {
              const unavailable = item.rate_to_rub === null;
              return (
                <DropdownMenu.RadioItem
                  className="currency-menu-item"
                  key={item.code}
                  value={item.code}
                  disabled={unavailable}
                >
                  <span className="currency-symbol">{item.symbol}</span>
                  <span className="currency-menu-copy">
                    <strong>{item.code === "RUB" ? "РУБ" : item.code}</strong>
                    <small>{item.name}</small>
                  </span>
                  <DropdownMenu.ItemIndicator className="currency-menu-check">
                    <Check aria-hidden="true" />
                  </DropdownMenu.ItemIndicator>
                </DropdownMenu.RadioItem>
              );
            })}
          </DropdownMenu.RadioGroup>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
